import { render, staticRenderFns } from "./SubmissionTrackersListItemContent.vue?vue&type=template&id=106863ba&scoped=true&"
import script from "./SubmissionTrackersListItemContent.vue?vue&type=script&lang=js&"
export * from "./SubmissionTrackersListItemContent.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionTrackersListItemContent.vue?vue&type=style&index=0&id=106863ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106863ba",
  null
  
)

export default component.exports